<template lang="pug">
  div
    #admzone492509
    //- iframe(ref="ads" src="//media1.admicro.vn/ads_codes/ads_box_492509.ads")
</template>

<script>
export default {
  mounted() {
    // window.admicroAD.unit.push(function() { window.admicroAD.show('admzone492509')});

    // let ads = document.createElement('script')
    // ads.setAttribute('async', 'async')
    // ads.setAttribute('src',"//media1.admicro.vn/ads_codes/ads_box_492509.ads")
    // this.$refs.ads.appendChild(ads)
  }
}
</script>




// WEBPACK FOOTER //
// Admzone.vue?56c49fdf